export default "__VITE_ASSET__B2NSTRpA__"